import React, { useState, useEffect } from "react";
import { Icon, Image } from "semantic-ui-react";
import { ENV, buildStorageUrl } from "../../../../../../utils";
import ReactAudioPlayer from "react-audio-player";
import "../TemplateManager.scss";

export const Smu02 = React.memo((props) => {
  const { slideId, activeSession } = props;
  const [title, setTitle] = useState("");
  const [titleAudio, setTitleAudio] = useState("");
  const [image, setImage] = useState("");
  const [audio, setAudio] = useState(null);

  /**
   * Updates the component state with the content of the selected slide in Smu02.js.
   *
   * This `useEffect` hook is triggered whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, particularly
   * in the `audios` array, the hook updates the component's state with the slide's title, the first audio's image,
   * title, and audio URL.
   *
   * Specifically, it performs the following actions:
   * - Sets the `title` state with the slide's content title.
   * - Sets the `image` state with the first audio's image URL from the slide's content.
   * - Sets the `titleAudio` state with the first audio's title from the slide's content.
   * - Sets the `audio` state with the first audio's audio URL from the slide's content.
   *
   * This ensures that the component reflects the content of the currently selected slide, displaying the title,
   * and the first audio's details (image, title, and audio URL), providing a focused and detailed view of the slide's content.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setTitle(slide.content.title);
      setImage(slide.content.audios[0].image);
      setTitleAudio(slide.content.audios[0].title);
      setAudio(slide.content.audios[0].audio);
    }
  }, [slideId]);

  return (
    <div className="column">
      <h3 className="show-slide__title">
        <Icon name="bookmark" />
        {title}
      </h3>
      <div className="show-slide__body">
        <Image bordered rounded fluid src={buildStorageUrl(image)} />
        <h4 className="show-slide__title">
          <Icon name="bookmark" />
          {titleAudio}
        </h4>
        <div className="media-slide__input-audio">
          <ReactAudioPlayer
            src={buildStorageUrl(audio?.preview)}
            controls
            controlsList="nodownload"
          />
        </div>
      </div>
    </div>
  );
});
